import {
    Grid,
    TableBody,
    TableContainer,
    TableRow,
    Table,
    TableHead,
    withStyles,
    TableCell,
    makeStyles,
    DialogTitle,
    CircularProgress,
    Typography,
    InputLabel
} from '@material-ui/core';
import React, { useEffect, useState, useMemo } from 'react';

import DialogComp from '../../../../Core/Modal/dialogModal';

import { GreenButton, SecondaryButton, TextBox } from '../../../../Core/FormInput';

import formatters from '../../../../Core/Grid/inputFormatter';

import { useWindowSize } from '../../../../Core/Controls/ScreenResolution';

import { postTCardCalendarHoliday, GetTCardByBookingDate } from '../../../../Core/Service/TCard-Calendar-service.js';

import TCardDashboardModal from '../Dashboard/T-cardModal.jsx';
import UserHoliday from './UserHoliday.jsx';

import { AppStorage } from '../../../../Core/Service/storage-service';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles({
    TCardStatusRender: {
        cursor: 'pointer',
        position: 'relative'
    }
});

const StyledTableCell = withStyles(() => ({
    head: {
        fontSize: 16,
        padding: '2px 8px',
        color: '#f50057'
    },
    body: {
        fontSize: 14,
        padding: '2px 8px'
    }
}))(TableCell);

const StyledTableRow = withStyles(() => ({
    root: {
        height: '40px',

        '&:nth-of-type(odd)': {
            backgroundColor: '#F5F5F5'
        },

        cursor: 'pointer'
    }
}))(TableRow);

const TCardStatusRender = ({ color, status }) => {
    const portalSetting = AppStorage.getPortalSetting();

    const classes = useStyles();

    const legendItems = useMemo(() => {
        if (!portalSetting) return [];

        return [
            {
                label: portalSetting?.portalSettingsCollectionDeliverText,
                background: portalSetting?.portalSettingsCollectionDeliverBgColor || 'black',
                color: portalSetting?.portalSettingsCollectionDeliverTextColor || 'white',
                st: 'cd'
            },
            {
                label: portalSetting?.portalSettingsCustomerWaitingText,
                background: portalSetting?.portalSettingsCustomerWaitingBgColor || 'black',
                color: portalSetting?.portalSettingsCustomerWaitingTextColor || 'white',
                st: 'waiting'
            },
            {
                label: portalSetting?.portalSettingsServiceText,
                background: portalSetting?.portalSettingsServiceBgColor || 'black',
                color: portalSetting?.portalSettingsServiceTextColor || 'white',
                st: 'service'
            },
            {
                label: portalSetting?.portalSettingsInspectionText,
                background: portalSetting?.portalSettingsInspectionBgColor || 'black',
                color: portalSetting?.portalSettingsInspectionTextColor || 'white',
                st: 'inspection'
            },
            {
                label: portalSetting?.portalSettingsMOTText,
                background: portalSetting?.portalSettingsMOTBgColor || 'black',
                color: portalSetting?.portalSettingsMOTTextColor || 'white',
                st: 'mot'
            },
            {
                label: portalSetting?.portalSettingsRepairText,
                background: portalSetting?.portalSettingsRepairBgColor || 'black',
                color: portalSetting?.portalSettingsRepairTextColor || 'white',
                st: 'repair'
            },
            {
                label: portalSetting?.portalSettingsNightShiftText,
                background: portalSetting?.portalSettingsNightShiftBgColor || 'black',
                color: portalSetting?.portalSettingsNightShiftTextColor || 'white',
                st: 'ns'
            },
            {
                label: portalSetting?.portalSettingsRecallJobText,
                background: portalSetting?.portalSettingsRecallJobBgColor || 'black',
                color: portalSetting?.portalSettingsRecallJobTextColor || 'white',
                st: 'recall'
            },
            {
                label: portalSetting?.portalSettingsTachoText,
                background: portalSetting?.portalSettingsTachoBgColor || 'black',
                color: portalSetting?.portalSettingsTachoTextColor || 'white',
                st: 'tacho'
            }
        ];
    }, [portalSetting]);

    return (
        <div style={{ background: color }} className={classes.TCardStatusRender}>
            <Grid container justifyContent="space-between" alignItems="center">
                <Grid item>
                    {status && (
                        <div
                            style={{
                                display: 'grid',
                                rowGap: 2,
                                gridTemplateColumns: `repeat(${legendItems.length}, 1fr)`,
                                justifyContent: 'flex-end'
                            }}
                        >
                            {legendItems.map((m) => (
                                <div
                                    key={m.st}
                                    style={{
                                        margin: '0px 2px',
                                        textAlign: 'center'
                                    }}
                                >
                                    {status[m.st] ? (
                                        <Typography
                                            style={{
                                                fontSize: 12,
                                                fontWeight: 600,
                                                background: m.background,
                                                color: m.color,
                                                padding: 2,
                                                minWidth: 30
                                            }}
                                        >
                                            {m.label}
                                        </Typography>
                                    ) : (
                                        <Typography
                                            style={{
                                                fontSize: 12,
                                                fontWeight: 600,
                                                padding: 2,
                                                minWidth: 30
                                            }}
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </Grid>
            </Grid>
        </div>
    );
};

const ViewHoliday = ({ selectedDate, branchID, isHoliday, onClose, modalData }) => {
    const [state, setState] = useState({
        list: [],
        loading: false,
        notes: modalData?.note,
        tCardID: ''
    });

    const [addHoliday, setAddHoliday] = useState(false);

    const [addUserHoliday, setAddUserHoliday] = useState(false);

    const [showNotes, setShowNotes] = useState(false);

    const [isHolidayVal, setIsHolidayVal] = useState(false);

    useWindowSize();

    const CallApiBydate = async () => {
        try {
            setState((prev) => ({
                ...prev,
                loading: true
            }));

            let res = await GetTCardByBookingDate(selectedDate);

            if (res?.success) {
                setState((prev) => ({
                    ...prev,
                    list: res?.data?.tCards || [],
                    loading: false
                }));
            } else {
                setState((prev) => ({
                    ...prev,
                    loading: false
                }));
            }
        } catch (error) {
            console.log(error);

            setState((prev) => ({
                ...prev,
                loading: false
            }));
        }
    };

    useEffect(() => {
        if (selectedDate) {
            CallApiBydate();
        }
    }, [selectedDate]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setState((prev) => ({
            ...prev,
            [name]: value
        }));
    };
    const handleHolidayModal = (value) => {
        setIsHolidayVal(value);

        setState((prev) => ({
            ...prev,
            notes: ''
        }));

        setShowNotes(true);
    };

    const handleHoliday = async () => {
        if (!state.notes?.trim()) return;

        try {
            setState((prev) => ({
                ...prev,
                loading: true
            }));

            const data = {
                BranchID: branchID,
                IsHoliday: isHolidayVal,
                Date: selectedDate,
                note: state.notes
            };

            let res = await postTCardCalendarHoliday(data);

            if (res?.data?.success) {
                setShowNotes(false);

                setState((prev) => ({
                    ...prev,
                    notes: ''
                }));

                onClose(true);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setState((prev) => ({
                ...prev,
                loading: false
            }));
        }
    };

    const handelModalClose = (cond, id, res) => {
        setState((prev) => ({
            ...prev,
            tCardID: id
        }));

        if (res) {
            CallApiBydate();
        }

        setAddHoliday(cond);
    };

    const RenderNotes = (props) => {
        return (
            <Grid container spacing={2} style={{ padding: 10, minWidth: 400 }}>
                <Grid item xs={12}>
                    <InputLabel shrink error>
                        Notes
                    </InputLabel>

                    <TextBox
                        multiline
                        rows={5}
                        fullWidth
                        variant="outlined"
                        placeholder="Enter Notes"
                        name="notes"
                        value={state.notes ? state.notes : modalData?.note}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <SecondaryButton
                                fullWidth
                                onClick={() => {
                                    setShowNotes(false);
                                    setState((prev) => ({
                                        ...prev,
                                        notes: ''
                                    }));
                                }}
                            >
                                Cancel
                            </SecondaryButton>
                        </Grid>

                        <Grid item xs={6}>
                            <GreenButton fullWidth onClick={handleHoliday} disabled={state.loading || !state.notes?.trim()} style={{ color: 'white' }}>
                                {state.loading ? 'Submitting...' : 'Submit'}
                            </GreenButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    const RenderTitle = () => {
        return (
            <Grid container spacing={1} direction="row" alignItems="center">
                <Grid item xs={6}>
                    <DialogTitle style={{ padding: 0, margin: 0 }}>Holiday Calendar - {formatters.DateFormatter(selectedDate)}</DialogTitle>
                </Grid>

                <Grid item xs={6} style={{ textAlign: 'right' }}>
                    <Grid container spacing={1} justifyContent="flex-end">
                        <Grid item>
                            {isHoliday ? (
                                <SecondaryButton
                                    onClick={() => handleHolidayModal(false)}
                                    style={{
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Remove Branch Holiday
                                </SecondaryButton>
                            ) : (
                                <GreenButton
                                    onClick={() => handleHolidayModal(true)}
                                    style={{
                                        whiteSpace: 'nowrap',
                                        color: 'white'
                                    }}
                                >
                                    Add Branch Holiday
                                </GreenButton>
                            )}
                        </Grid>

                        <Grid item>
                            <GreenButton
                                onClick={() => setAddUserHoliday(true)}
                                style={{
                                    whiteSpace: 'nowrap',
                                    color: 'white',
                                    minWidth: 140
                                }}
                            >
                                User Holidays
                            </GreenButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    return (
        <>
            <DialogComp onClose={() => onClose(false)} title={RenderTitle()} maxWidth="lg" fullWidth>
                {state.loading ? (
                    <Grid container justifyContent="center" alignItems="center" style={{ height: '64vh' }}>
                        <CircularProgress />
                    </Grid>
                ) : (
                    <Grid container spacing={2} style={{ paddingBottom: 6 }}>
                        {modalData.note ? (
                            <Grid item xs={12}>
                                <Alert severity="info" icon={false}>
                                    {modalData.note || ''}
                                </Alert>
                            </Grid>
                        ) : (
                            ''
                        )}
                        <Grid item xs={12}>
                            {' '}
                            <TableContainer
                                style={{
                                    border: '1px solid rgba(0,0,0,0.2)',
                                    height: 'calc(100vh - 455px)'
                                }}
                                className="custom-scroll"
                            >
                                <Table>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell width={50}>ID</StyledTableCell>

                                            <StyledTableCell width={100}>Reg No</StyledTableCell>

                                            <StyledTableCell width={250}>Customer</StyledTableCell>

                                            <StyledTableCell width={350}>T-Card Items</StyledTableCell>

                                            <StyledTableCell width={200}>Status</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>

                                    <TableBody>
                                        {state.list.map((m) => (
                                            <StyledTableRow key={m.tCardsID} onClick={() => handelModalClose(true, m.tCardsID, false)}>
                                                <StyledTableCell>{m.tCardsID}</StyledTableCell>

                                                <StyledTableCell
                                                    style={{
                                                        fontWeight: 600
                                                    }}
                                                >
                                                    {m.reg}
                                                </StyledTableCell>

                                                <StyledTableCell>{m.cust}</StyledTableCell>

                                                <StyledTableCell>
                                                    <TCardStatusRender
                                                        status={{
                                                            recall: m.recall,
                                                            tacho: m.tacho,
                                                            mot: m.mot,
                                                            repair: m.repair,
                                                            inspection: m.inspection,
                                                            cd: m.cd,
                                                            waiting: m.waiting,
                                                            service: m.service,
                                                            ns: m.ns
                                                        }}
                                                    />
                                                </StyledTableCell>

                                                <StyledTableCell>{m.status}</StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>

                        {addHoliday && <TCardDashboardModal id={state.tCardID} onClose={handelModalClose} />}

                        {addUserHoliday && (
                            <DialogComp title="Add User Holiday" onClose={() => setAddUserHoliday(false)} maxWidth="md" fullWidth>
                                <div style={{ padding: 20 }}>
                                    <UserHoliday selectedDate={selectedDate} branchID={branchID} onClose={() => setAddUserHoliday(false)} />
                                </div>
                            </DialogComp>
                        )}
                    </Grid>
                )}
            </DialogComp>

            {showNotes && (
                <DialogComp title="Notes" onClose={() => setShowNotes(false)} maxWidth="sm" fullWidth>
                    {RenderNotes()}
                </DialogComp>
            )}
        </>
    );
};

export default ViewHoliday;
